// src/pages/Dashboard/CompanyListDashboard.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import companyService from '../../services/company.service';
import CompanyCard from '../../components/CompanyCard/CompanyCard';
import './Dashboard.css';

const CompanyListDashboard = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const [companies, setCompanies] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchCompanies();
  }, []);

  const fetchCompanies = async () => {
    setLoading(true);
    setError(null);
    try {
      const response = await companyService.getAllCompanies();
      if (response.success) {
        setCompanies(response.data);
      } else {
        setError(response.message || 'Failed to fetch companies');
      }
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to fetch companies');
      console.error('Error fetching companies:', err);
    } finally {
      setLoading(false);
    }
  };

  const handleCompanyClick = (companyId) => {
    // Navigate to company-specific admin dashboard
    navigate(`/company/${companyId}/dashboard`);
  };

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2 className="dashboard-title"></h2>
        <div className="dashboard-user-info">
          <span className="user-name">Welcome, {user?.name || user?.username}</span>
          <span className="user-role">{user?.roleDisplayName}</span>
        </div>
      </div>

      <div className="dashboard-content">
        <div className="section-header">
          <h3 className="section-title">Companies</h3>
          {companies.length > 0 && (
            <span className="section-count">{companies.length} companies</span>
          )}
        </div>

        {loading && (
          <div className="loading-container">
            <div className="spinner"></div>
            <p>Loading companies...</p>
          </div>
        )}

        {error && (
          <div className="error-container">
            <p className="error-message">{error}</p>
            <button className="retry-button" onClick={fetchCompanies}>
              Retry
            </button>
          </div>
        )}

        {!loading && !error && companies.length === 0 && (
          <div className="empty-state">
            <div className="empty-icon">🏢</div>
            <h3>No Companies Found</h3>
            <p>There are no companies in the system yet.</p>
          </div>
        )}

        {!loading && !error && companies.length > 0 && (
          <div className="companies-grid">
            {companies.map((company) => (
              <div key={company.id} onClick={() => handleCompanyClick(company.id)}>
                <CompanyCard company={company} />
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CompanyListDashboard;